import { ReduxService } from 'dashboard-services/services';

import { csvParserActions } from 'actions/modules/tools';

export const csvParserInitialState = {
  id: undefined,
  open: false,
  provider: undefined
}

export default (state = csvParserInitialState, action) => {

  switch (action.type) {
    case csvParserActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}